export default __webpack_public_path__ + "static/media/ic-fruit-peaches.45a167be.svg";